/*
 * Moji – moteur d'affichage des pages
 * ------------------------------------
 * Chaque page du thème contient deux maquettes (ordinateur 1440 px et mobile 390 px)
 * écrites en HTML avec des « trous » {{ valeur }}, des boucles <sc-for> et des
 * conditions <sc-if>, plus un petit script de logique (class Component).
 * Ce fichier les affiche avec React, choisit la bonne version selon la largeur de
 * l'écran et met la page à l'échelle pour qu'elle soit identique à la maquette.
 */
(function () {
  'use strict';
  var h = React.createElement;
  var MOBILE_MAX = 900;     // en dessous : version mobile
  var MOBILE_SCALE_MAX = 1.25; // la version mobile ne grossit pas au-delà
  // Taille de la version ordinateur, en % de la maquette (1440 px) : réglable dans
  // l'éditeur du thème (Paramètres du thème > Moji > Taille sur ordinateur).
  function zoomOrdinateur() {
    var z = parseFloat(document.body.getAttribute('data-moji-zoom'));
    return (z >= 40 && z <= 120 ? z : 80) / 100;
  }
  var TRANSPARENT = /rgba\(0, 0, 0, 0\)|transparent/;

  /* ---------- évaluation des expressions {{ … }} ---------- */
  function lookup(scope, path) {
    var parts = path.split('.');
    var v = scope;
    for (var i = 0; i < parts.length; i++) {
      if (v == null) return undefined;
      v = v[parts[i]];
    }
    return v;
  }
  function evaluate(scope, expr) {
    var e = String(expr).trim();
    if (!e) return undefined;
    if (e[0] === '!') return !evaluate(scope, e.slice(1));
    var m = e.match(/^(.+?)\s*(===|!==|==|!=)\s*(.+)$/);
    if (m) {
      var a = evaluate(scope, m[1]), b = evaluate(scope, m[3]);
      return m[2] === '===' ? a === b : m[2] === '!==' ? a !== b : m[2] === '==' ? a == b : a != b;
    }
    if (e === 'true') return true;
    if (e === 'false') return false;
    if (e === 'null') return null;
    if (e === 'undefined') return undefined;
    if (/^-?\d+(\.\d+)?$/.test(e)) return Number(e);
    if (e.length > 1 && (e[0] === '"' || e[0] === "'") && e[e.length - 1] === e[0]) return e.slice(1, -1);
    return lookup(scope, e);
  }
  var HOLE = /\{\{([\s\S]+?)\}\}/g;
  function getter(text) {
        var whole = text.match(/^\s*\{\{((?:(?!\{\{|\}\})[\s\S])+)\}\}\s*$/);
    if (whole) return function (s) { return evaluate(s, whole[1]); };
    if (text.indexOf('{{') < 0) return function () { return text; };
    var parts = text.split(HOLE);
    return function (s) {
      var out = '';
      for (var i = 0; i < parts.length; i++) {
        if (i % 2) { var v = evaluate(s, parts[i]); out += v == null ? '' : v; } else out += parts[i];
      }
      return out;
    };
  }

  /* ---------- conversion des attributs HTML en props React ---------- */
  var EVENTS = {
    onclick: 'onClick', oninput: 'onInput', onchange: 'onChange', onsubmit: 'onSubmit',
    onkeydown: 'onKeyDown', onkeyup: 'onKeyUp', onfocus: 'onFocus', onblur: 'onBlur',
    onpointerdown: 'onPointerDown', onpointermove: 'onPointerMove', onpointerup: 'onPointerUp',
    onpointercancel: 'onPointerCancel', onpointerenter: 'onPointerEnter', onpointerleave: 'onPointerLeave',
    onmouseenter: 'onMouseEnter', onmouseleave: 'onMouseLeave', ondoubleclick: 'onDoubleClick'
  };
  var RENAME = {
    'class': 'className', 'for': 'htmlFor', tabindex: 'tabIndex', readonly: 'readOnly',
    maxlength: 'maxLength', autocomplete: 'autoComplete', spellcheck: 'spellCheck',
    autofocus: 'autoFocus', 'accept-charset': 'acceptCharset', crossorigin: 'crossOrigin',
    srcset: 'srcSet', colspan: 'colSpan', rowspan: 'rowSpan', enctype: 'encType', novalidate: 'noValidate'
  };
  var BOOLEANS = { disabled: 1, checked: 1, required: 1, hidden: 1, selected: 1, multiple: 1, readonly: 1, autofocus: 1, novalidate: 1 };
  function styleObject(str) {
    var o = {};
    String(str || '').split(';').forEach(function (decl) {
      var i = decl.indexOf(':');
      if (i < 0) return;
      var k = decl.slice(0, i).trim(), v = decl.slice(i + 1).trim();
      if (!k) return;
      if (k.indexOf('--') !== 0) k = k.replace(/-([a-z])/g, function (_, c) { return c.toUpperCase(); });
      if (/^(webkit|moz|ms)[A-Z]/.test(k)) k = k[0].toUpperCase() + k.slice(1);
      o[k] = v;
    });
    return o;
  }

  /* ---------- compilation d'un nœud du gabarit ---------- */
  function compileChildren(node) {
    var out = [];
    node.childNodes.forEach(function (c) { var f = compile(c); if (f) out.push(f); });
    return out;
  }
  function renderChildren(fns, scope) {
    var out = [];
    for (var i = 0; i < fns.length; i++) {
      var r = fns[i](scope, i);
      if (r !== null && r !== undefined && r !== false) out.push(r);
    }
    return out;
  }
  function compile(node) {
    if (node.nodeType === 3) {
      var t = node.nodeValue;
      if (!t.trim() && t.indexOf(' ') < 0) return null;
      if (t.indexOf('{{') < 0) return function () { return t; };
      var g = getter(t);
      return function (s) { return String(g(s)); };
    }
    if (node.nodeType !== 1) return null;
    var tag = node.localName;
    if (tag === 'sc-for') {
      var list = getter(node.getAttribute('list') || ''), as = node.getAttribute('as') || 'item';
      var kids = compileChildren(node);
      return function (s, key) {
        var arr = list(s);
        if (!Array.isArray(arr)) arr = [];
        return h(React.Fragment, { key: key }, arr.map(function (item, i) {
          var sc = Object.create(s); sc[as] = item; sc.$index = i;
          return h(React.Fragment, { key: i }, renderChildren(kids, sc));
        }));
      };
    }
    if (tag === 'sc-if') {
      var val = getter(node.getAttribute('value') || '');
      var kidsIf = compileChildren(node);
      return function (s, key) {
        return val(s) ? h(React.Fragment, { key: key }, renderChildren(kidsIf, s)) : null;
      };
    }
    var attrs = [];
    for (var i = 0; i < node.attributes.length; i++) {
      var a = node.attributes[i], n = a.name;
      if (n.indexOf('hint-') === 0) continue;
      attrs.push([n, getter(a.value), a.value]);
    }
    var children = compileChildren(node);
    var svg = node.namespaceURI === 'http://www.w3.org/2000/svg';
    var isInput = tag === 'input' || tag === 'textarea' || tag === 'select';
    return function (s, key) {
      var props = { key: key };
      for (var j = 0; j < attrs.length; j++) {
        var n = attrs[j][0], v = attrs[j][1](s);
        if (EVENTS[n]) {
          if (typeof v === 'function') {
            props[EVENTS[n]] = v;
            if (n === 'oninput' && isInput) props.onChange = v;
          }
          continue;
        }
        if (n === 'style') { props.style = styleObject(v); continue; }
        if (isInput && n === 'value') {
          props.value = v == null ? '' : v;
          if (!props.onChange) props.onChange = function () {};
          continue;
        }
        if (BOOLEANS[n] && !svg) { props[RENAME[n] || n] = v !== false && v !== 'false'; continue; }
        if (n === 'aria-pressed' || n === 'aria-expanded' || n === 'aria-selected' || n === 'aria-checked') { props[n] = v; continue; }
        props[RENAME[n] || n] = v;
      }
      if (isInput && tag !== 'select' && !('value' in props) && !('defaultValue' in props)) { /* champ libre */ }
      var kids = renderChildren(children, s);
      if (tag === 'textarea') return h(tag, props);
      return h.apply(null, [tag, props].concat(kids));
    };
  }

  /* ---------- logique des pages ---------- */
  function DCLogic(props) { this.props = props || {}; this.state = {}; }
  DCLogic.prototype.setState = function (partial) {
    var p = typeof partial === 'function' ? partial(this.state) : partial;
    this.state = Object.assign({}, this.state, p);
    if (this.__rerender) this.__rerender();
  };
  DCLogic.prototype.forceUpdate = function () { if (this.__rerender) this.__rerender(); };
  DCLogic.prototype.renderVals = function () { return {}; };
  DCLogic.prototype.componentDidMount = function () {};

  function makeLogic(code) {
    if (!code || !code.trim()) return function () { return new DCLogic(); };
    var Cls = new Function('DCLogic', 'React', code + '\n;return typeof Component !== "undefined" ? Component : null;')(DCLogic, React);
    return function (props) { return Cls ? new Cls(props) : new DCLogic(props); };
  }

  /* ---------- montage d'une page ---------- */
  function readAssets(app) {
    var el = app.querySelector('script.moji-assets');
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
  }
  function withAssets(text, assets) {
    return text.replace(/__A:([A-Za-z0-9._-]+)__/g, function (m, name) { return assets[name] || name; });
  }
  function part(app, kind, version) {
    var el = app.querySelector('[data-moji="' + kind + '"][data-version="' + version + '"]');
    return el ? (el.tagName === 'TEMPLATE' ? el.innerHTML : el.textContent) : '';
  }

  function mount(app) {
    var assets = readAssets(app);
    var wide = window.innerWidth > MOBILE_MAX;
    var version = wide ? 'desktop' : 'mobile';
    var redirect = app.getAttribute('data-desktop-redirect');
    if (wide && redirect) { location.replace(redirect); return; }
    if (!app.querySelector('[data-moji="markup"][data-version="' + version + '"]')) { app.setAttribute('data-mounted', 'aucune'); return; }
    var markup = withAssets(part(app, 'markup', version), assets);
    var css = withAssets(part(app, 'css', version), assets);
    var code = withAssets(part(app, 'logic', version), assets);
    var props = {};
    try { props = JSON.parse(part(app, 'props', version) || '{}'); } catch (e) {}
    var config = {};
    var cfgEl = app.querySelector('script.moji-config');
    try { if (cfgEl) config = JSON.parse(cfgEl.textContent); } catch (e) {}
    window.MOJI_CONFIG = Object.assign(window.MOJI_CONFIG || {}, config);

    var cssEl = app.querySelector('[data-moji="css"][data-version="' + version + '"]');
    var cssKey = (cssEl && cssEl.getAttribute('data-key')) || app.id;
    if (!document.querySelector('style[data-moji-css="' + cssKey + '"]')) {
      var style = document.createElement('style');
      style.setAttribute('data-moji-css', cssKey);
      style.textContent = css;
      document.head.appendChild(style);
    }

    // Largeur de l'écran par rapport à la maquette : sert à ajouter des motifs aux barres décoratives
    var largeurMaquette = version === 'mobile' ? 390 : 1440;
    var echelle = version === 'mobile' ? Math.min(window.innerWidth / 390, MOBILE_SCALE_MAX) : Math.min(window.innerWidth, 1440 * zoomOrdinateur()) / 1440;
    window.MOJI_ETIREMENT = Math.max(1, document.documentElement.clientWidth / (largeurMaquette * echelle));

    var tpl = document.createElement('template');
    tpl.innerHTML = markup;
    var fns = compileChildren(tpl.content);
    var logic = makeLogic(code)(props);

    var stage = document.createElement('div');
    stage.className = 'moji-stage' + (app.hasAttribute('data-overlay') ? ' moji-stage--over' : '');
    var root = document.createElement('div');
    root.className = 'moji-root';
    stage.appendChild(root);
    app.appendChild(stage);

    function App() {
      var st = React.useState(0);
      var force = st[1];
      logic.__rerender = function () { force(function (x) { return x + 1; }); };
      React.useEffect(function () { logic.componentDidMount(); fit(); }, []);
      React.useEffect(function () { fit(); });
      var vals = Object.assign({ envoye: /contact_posted=true/.test(location.search) }, logic.renderVals() || {});
      return h(React.Fragment, null, renderChildren(fns, vals));
    }

    function fit() {
      var page = root.firstElementChild;
      while (page && page.tagName && page.tagName.toLowerCase() === 'svg' && page.getAttribute('width') === '0') page = page.nextElementSibling;
      if (!page) return;
      var w = page.offsetWidth, hgt = page.offsetHeight;
      if (!w) return;
      var avail = document.documentElement.clientWidth;
      var s = version === 'mobile' ? Math.min(avail / w, MOBILE_SCALE_MAX) : Math.min(avail, w * zoomOrdinateur()) / w;
      root.style.width = w + 'px';
      root.style.transform = 'scale(' + s + ')';
      root.style.left = Math.max(0, (avail - w * s) / 2) + 'px';
      stage.style.height = Math.ceil(hgt * s) + 'px';
      // Les fonds de couleur des bandes (en-tête, sections, pied de page) continuent jusqu'aux bords de l'écran
      page.style.overflowX = 'visible';
      page.style.overflowY = app.hasAttribute('data-overlay') ? 'visible' : 'clip';
      var fondPage = getComputedStyle(page).backgroundColor;
      for (var c = page.firstElementChild; c; c = c.nextElementSibling) {
        var cs = getComputedStyle(c);
        if (cs.position === 'absolute' || cs.position === 'fixed') continue;
        if (c.classList.contains('wave')) {
          // barre festonnée : elle s'élargit elle-même jusqu'aux bords de l'écran
          var bord = Math.max(0, (avail - w * s) / 2) / s;
          c.style.marginLeft = -Math.ceil(bord) + 'px';
          c.style.width = (w + 2 * Math.ceil(bord)) + 'px';
          c.style.boxSizing = 'border-box';
          c.style.clipPath = 'none';
          continue;
        }
        var bg = cs.backgroundColor;
        var largeur = c.offsetWidth;
        if (bg && !TRANSPARENT.test(bg)) {
          c.style.boxShadow = '0 0 0 100vmax ' + bg;
        } else {
          // Bande en plusieurs morceaux (ex. moitié bleue / moitié rose) : on prolonge la couleur de chaque bord
          var g = couleurBord(c, 'left') || fondPage, d = couleurBord(c, 'right') || fondPage;
          if (!g || TRANSPARENT.test(g) || !d || TRANSPARENT.test(d)) continue;
          c.style.boxShadow = [-largeur, -2 * largeur].map(function (x) { return x + 'px 0 0 0 ' + g; })
            .concat([largeur, 2 * largeur].map(function (x) { return x + 'px 0 0 0 ' + d; })).join(', ');
        }
        c.style.clipPath = 'inset(-1px -100vmax)';
      }
      // Le bandeau qui défile occupe aussi toute la largeur de l'écran
      var marge = Math.max(0, (avail - w * s) / 2) / s;
      page.querySelectorAll('.mq').forEach(function (mq) {
        if (mq.parentElement) mq.parentElement.style.overflow = 'visible';
        mq.style.marginLeft = -Math.ceil(marge) + 'px';
      });
         // Le carrousel de la section réseaux continue jusqu'au bord droit de l'écran
      page.querySelectorAll('[data-bord-droit]').forEach(function (el) {
        el.style.marginRight = -Math.ceil(marge) + 'px';
        el.style.setProperty('--mj-extra', Math.ceil(marge) + 'px');
      });
    }
    // Couleur de fond de l'élément qui touche le bord gauche ou droit d'une bande
    function couleurBord(bande, cote) {
      var r = bande.getBoundingClientRect(), meilleur = null, aire = 0;
      var els = bande.querySelectorAll('*');
      for (var i = 0; i < els.length && i < 400; i++) {
        var e = els[i], b = e.getBoundingClientRect();
        if (b.height < r.height * 0.6) continue;
        var touche = cote === 'left' ? Math.abs(b.left - r.left) < 3 : Math.abs(b.right - r.right) < 3;
        if (!touche) continue;
        var col = getComputedStyle(e).backgroundColor;
        if (!col || TRANSPARENT.test(col)) continue;
        if (b.width * b.height > aire) { aire = b.width * b.height; meilleur = col; }
      }
      return meilleur;
    }
    window.addEventListener('resize', function () {
      if ((window.innerWidth > MOBILE_MAX) !== wide) { location.reload(); return; }
      fit();
    });
    window.addEventListener('load', fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);

    var r = ReactDOM.createRoot ? ReactDOM.createRoot(root) : null;
    if (r) r.render(h(App)); else ReactDOM.render(h(App), root);
    app.__moji = { root: r, stage: stage };
    app.setAttribute('data-mounted', version);
    if (location.hash && !window.__mojiAncre) window.__mojiAncre = setTimeout(function () {
      var target = document.getElementById(location.hash.slice(1));
      if (target) window.scrollTo(0, target.getBoundingClientRect().top + window.scrollY);
    }, 400);
  }

  function start() { document.querySelectorAll('.moji-app:not([data-mounted])').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  // Éditeur de thème Shopify : une section modifiée est rechargée, on la réaffiche
  document.addEventListener('shopify:section:unload', function (e) {
    var app = e.target && e.target.querySelector('.moji-app');
    if (app && app.__moji && app.__moji.root) app.__moji.root.unmount();
  });
  document.addEventListener('shopify:section:load', function (e) {
    var app = e.target && e.target.querySelector('.moji-app');
    if (app && !app.hasAttribute('data-mounted')) mount(app);
  });
  window.MojiRuntime = { DCLogic: DCLogic, mount: mount };
})();
